import React from 'react';
import Nabvar from '../Components/Navbar/OptimizedNavbar'
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../Components/Footer/Footer'
import Cart from '../Components/Cart/Cart'
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import BotHaimpress from '../Components/BotHaimpress/BotHaimpress';
export default function IndexLayout() {



    const isScreenLarge = useMediaQuery('(min-width: 1024px)');
    return (
        <div >
            <TitleMeta />
            {isScreenLarge ?
                <>
                    <Nabvar />
                    <Outlet />
                    <Footer />
                    <Cart />
                    <BotHaimpress />
                </> :
                <>

                    <Outlet />
                    <Footer />
                    <Cart />
                    <BotHaimpress />
                </>}

            <div className='espaciobg2'>

            </div>

        </div>
    );
}
